import { AfterViewInit, Component, ContentChildren, ElementRef, Input, QueryList } from '@angular/core';
import { AccordionProps, accordionStyles } from '@kite_aerolab/shared/components';
import { AccordionItemComponent } from './accordion-item.component';

@Component({
  selector: 'kite-accordion',
  template: `
    <div (keyup)="handleKeyUp($event)" [ngClass]="accordionStyles">
      <ng-content></ng-content>
    </div>
  `,
})
export class AccordionComponent implements AfterViewInit {
  accordionItems: any[];
  accordionRefs: any[];
  nextIndex = 0;
  selected = -1;
  @ContentChildren(AccordionItemComponent) childrenAccordionItems: QueryList<AccordionItemComponent>;
  @ContentChildren(AccordionItemComponent, { read: ElementRef })
  childrenAccordionItemsRefs: QueryList<AccordionItemComponent>;

  constructor(public elem: ElementRef) {}

  _allowMultiple: boolean;

  /* Número de ítems sobre los que iterar al hacer keydown */
  @Input() triggerCount = 0;

  /* Número de ítems sobre los que iterar al hacer keydown */
  @Input() position: AccordionProps['position']


  /**
   * Css del componente
   */
  @Input() css: AccordionProps['css'];

  /**
  * Css del componente
  */
  @Input() variant: AccordionProps['variant'];

  /**
   * Permite abrir varios items a la vez si está en true
   */
  @Input()
  get allowMultiple() {
    return this._allowMultiple;
  }

  set allowMultiple(val: boolean) {
    this._allowMultiple = val;
    if (!val) {
      this.selected = -1;
    }
    if (this.accordionItems) {
      this.updateSelected(this.accordionItems)
      this.updateAllowMultiple(this.accordionItems)      
      !val && this.closeAllItems(this.accordionItems)
    }
  }

  _activeIndex: number | undefined;

  /**
   * Panel abierto por default
   */
  @Input()
  get activeIndex() {
    return this._activeIndex;
  }

  set activeIndex(val: AccordionProps['activeIndex']) {
    this._activeIndex = val;
    this.selected = val !== undefined ? val : -1;
    if (this.accordionItems) {
      this.updateSelected(this.accordionItems);
    }
  }

  /* Maneja el focus de los items en la navegación por teclado */
  handleKeyUp(event: any) {
    switch (event.key) {
      case 'Home':
        this.nextIndex = 0;
        break;
      case 'End':
        this.nextIndex = this.triggerCount - 1;
        break;
      case 'ArrowDown':
        this.nextIndex = this.nextIndex + 1;
        if (this.nextIndex === this.triggerCount) {
          this.nextIndex = 0;
        }
        break;
      case 'ArrowUp':
        this.nextIndex = this.nextIndex - 1;
        if (this.nextIndex < 0) {
          this.nextIndex = this.triggerCount - 1;
        }
        break;
    }
    if (event.key === 'Home' || event.key === 'End' || event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      this.accordionRefs[this.nextIndex].nativeElement.children[0].children[0].focus();
    }
  }

  updateChildrenProps(children: any) {
    children.forEach((child: any, index: number) => {
      child.id = index;
      child.selected = this.selected;
      child.allowMultiple = this.allowMultiple;
      child.onClick.subscribe((value: number) => {
        this.selected = value;
        children.forEach((child: any) => {
          child.selected = this.selected;
        });
      });
    });
  };

  updateAllowMultiple (children: any) {
    children.forEach((child: any) => {
      child.allowMultiple = this.allowMultiple
    })
  }

  closeAllItems (children: any) {
    children.forEach((child: any) => {
      child.isOpen = false
    })
  }

  updateSelected (children: any) {
    children.forEach((child: any) => {
      child.selected = this.selected
    }) 
  }

  ngAfterViewInit() {
    this.selected = this.activeIndex !== undefined ? this.activeIndex : -1;
    /* Guarda en accordionRefs solo los items habilitados (para manejar luego el focus) */
    this.accordionRefs = this.childrenAccordionItemsRefs
      .toArray()
      .map((accordionItem: any) => {
        return !accordionItem.nativeElement.children[0].children[0].disabled ? accordionItem : null;
      })
      .filter((i) => i !== null);

    /* Guarda en accordionItems solo los items habilitados. Les pasa las props */
    this.accordionItems = this.childrenAccordionItems
      .toArray()
      .map((accordionItem) => {
        return !accordionItem.isDisabled ? accordionItem : null;
      })
      .filter((i) => i !== null);
    this.updateChildrenProps(this.accordionItems);
    this.triggerCount = this.accordionItems.length;
  };

  public get accordionStyles(): string[] {
    return [
      accordionStyles({
        css: this.css,
        variant: this.variant,
        position: this.position
      }).className,
    ];
  }
}
